import type { CompetitorFiltersInput } from "@/lib/queries/dashboard.queries";

/**
 * Null myBrand/myIndustry so competitor drilldown SQL stays benchmark-scoped.
 * Leave industryProducts intact — Products to Compare still filters rt.product.
 */
export function toDrilldownCompetitorQueryFilters(
  applied: CompetitorFiltersInput,
): CompetitorFiltersInput {
  return {
    ...applied,
    myBrand: null,
    myIndustry: null,
  };
}
